import { render, staticRenderFns } from "./CategoryTypes.vue?vue&type=template&id=41bfd198"
import script from "./CategoryTypes.vue?vue&type=script&lang=js"
export * from "./CategoryTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports